import { Autocomplete, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { SearchWrapper } from "./searchablestyle";

const SearchableDropdown = (props) => {
  const [filteredData, _filteredData] = useState([]);

  useEffect(() => {
    if (props.dropdownData?.length) {
      _filteredData(
        props.dropdownData.map((element) => ({
          label: element.fullname,
          value: element.id,
        }))
      );
    }
  }, [props.dropdownData]);

  // find the selected option object for Autocomplete
  const selectedOption =
    filteredData.find((o) => o.value === props.val) || null;

  return (
    <SearchWrapper>
      <Autocomplete
        key={props.name}
        disableClearable
        className={props.className}
        options={filteredData}
        sx={{ width: 250 }}
        value={selectedOption}
        disabled={props.disabled ?? false}
        forcePopupIcon={true}
        getOptionLabel={(option) => option?.label || ""}
        renderOption={(optProps, option) => (
          <li {...optProps} key={props.name + "" + option.value}>
            {option.label}
          </li>
        )}
        onChange={(event, newValue) => {
          props.setChangeValue(newValue?.value ?? "");
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={props.placeholder}
            onChange={(e) => {
              if (e.target.value == "") {
                props.setChangeValue("");
              }
            }}
            id={props.id ? props.id : "searchableField"}
          />
        )}
      />
    </SearchWrapper>
  );
};

export default SearchableDropdown;
